import { buildCreateSlice, asyncThunkCreator } from '@reduxjs/toolkit';

import { initialState } from './initial';
import { reducers } from './reducers';

export const createAppSlice = buildCreateSlice({
  creators: { asyncThunk: asyncThunkCreator },
});

export const channelAdminsSlice = createAppSlice({
  name: 'channelAdmins',
  initialState,
  reducers,
});

export const {
  getAdmins,
  getAdminContacts,
  setWorkingPermissions,
  removeAdmin,
  addAdmin,
  addAdminToProject,
  addExistingAdminToProject,
  updateUserChannelSettings,
  unlockEmail,
  getChannelProducersAndPresenters,
} = channelAdminsSlice.actions;

export default channelAdminsSlice.reducer;
